import { consentVersion } from "helpers";
import { BasicUserConsentDialog } from "pages/consent/BasicUserConsentDialog";
import React, { useCallback, useEffect, useState } from "react";
import { getStore } from "store";
import { selectPartnerBasicConsent } from "store/slices/partner.store";

type PartnerConsentProviderProps = {
  children: React.ReactNode;
};

interface PartnerConsentContextType {}

const PartnerConsentContext = React.createContext<PartnerConsentContextType | undefined>(undefined);

export default function PartnerConsentProvider(props: PartnerConsentProviderProps) {
  const [consentsAccepted, setConsentsAccepted] = useState(false);
  const [openBasic, setOpenBasic] = useState(false);

  const checkMissingConsent = useCallback(() => {
    var partnerBasicConsent = selectPartnerBasicConsent(getStore().getState());
    if (partnerBasicConsent && consentVersion.basic.version === partnerBasicConsent.version) {
      setConsentsAccepted(true);
    } else {
      setConsentsAccepted(false);
      setOpenBasic(true);
    }
  }, []);

  useEffect(() => {
    checkMissingConsent();
  }, [checkMissingConsent]);

  return (
    <PartnerConsentContext.Provider value>
      <BasicUserConsentDialog
        open={openBasic}
        partnerView
        setOpen={(open: boolean) => {
          setOpenBasic(open);
          checkMissingConsent();
        }}
      />
      {consentsAccepted ? props.children : null}
    </PartnerConsentContext.Provider>
  );
}

export function useConsent() {
  const context = React.useContext(PartnerConsentContext);
  if (context === undefined) {
    throw new Error("useConsents must be used within a ConsentContext");
  }
  return context;
}
